/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Revert_BtnInputs */

const vi_station_voice_revert_btn = /** @type {(inputs: Station_Voice_Revert_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn tác`)
};

/**

* @param {Station_Voice_Revert_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_revert_btn = /** @type {((inputs?: Station_Voice_Revert_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Revert_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_revert_btn(inputs)
});